import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const Hamburger = ({ open, colorOption = 'bg-pink-500' }) => {
  return (
    <button className="relative w-10 h-10 text-gray-500 bg-transparent focus:outline-none">
      <span className="sr-only">Open main menu</span>
      <div className="absolute block w-8 transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
        <span
          aria-hidden="true"
          className={cx(
            'block absolute h-0.5 w-8 transform transition duration-300 ease-in-out',
            colorOption,
            {
              'rotate-45': open,
              '-translate-y-3': !open,
            }
          )}
        ></span>
        <span
          aria-hidden="true"
          className={cx(
            'block absolute h-0.5 w-8 transform transition duration-300 ease-in-out ',
            colorOption,
            {
              'opacity-0': open,
            }
          )}
        ></span>
        <span
          aria-hidden="true"
          className={cx(
            'block absolute h-0.5 w-8 transform transition duration-300 ease-in-out',
            colorOption,
            {
              '-rotate-45': open,
              'translate-y-3': !open,
            }
          )}
        ></span>
      </div>
    </button>
  )
}

Hamburger.propTypes = {
  open: PropTypes.bool.isRequired,
}

export default Hamburger
